import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from "redux";

import {fetchHomeMediasAll} from '../../../../../creators/home.medias.all';

import Carousel from '../../../../components/Carousel';
import Thumb from '../../../../components/Thumb';
import {shuffleArray} from "../../../../../libs/helper";

class PhotoHomeMember extends React.Component {

    constructor(props){
        super(props);
        this.props.fetchHomeMediasAll();
    }
    shouldComponentUpdate(nextProps, nextState) {
        if(nextProps.mediasLoading !== this.props.mediasLoading && nextProps.mediasInitialized){
            return true;
        }
        return false;
    }

    render() {
        let medias = this.props.medias || [];
        if(this.props.mediasInitialized){
            medias = shuffleArray(medias, 18);
        }
        return (
            <Carousel>
                <div className="pane">
                    <div className="row">
                        {this.props.mediasInitialized && medias.slice(0, 6).map((photo) => (
                            <Thumb
                                key={photo._id}
                                {...photo}
                            />
                        ))}
                    </div>
                </div>
                <div className="pane">
                    <div className="row">
                        {this.props.mediasInitialized && medias.slice(6, 12).map((photo) => (
                            <Thumb
                                key={photo._id}
                                {...photo}
                            />
                        ))}
                    </div>
                </div>
                <div className="pane">
                    <div className="row">
                        {this.props.mediasInitialized && medias.slice(12, 18).map((photo) => (
                            <Thumb
                                key={photo._id}
                                {...photo}
                            />
                        ))}
                    </div>
                </div>
            </Carousel>
        )
    }

}


const mapStateToProps = (state) => {
    return {
        medias: state.homeMediaAll.data,
        mediasLoading: state.homeMediaAll.loading,
        mediasInitialized: state.homeMediaAll.initialized,
    }
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
    fetchHomeMediasAll
}, dispatch);


export default connect(mapStateToProps, mapDispatchToProps)(PhotoHomeMember);
